const SESSION_KEY = 'care_guardian_maintenance_access_v1';

function availableStorage() {
  try { return window.sessionStorage; } catch { return null; }
}

export function saveMaintenanceSession(token, access) {
  const session = {
    token,
    staff: access.staff,
    centres: Array.isArray(access.centres) ? access.centres : [],
    initial_centre_id: Number(access.initial_centre_id),
    selected_centre_id: Number(access.initial_centre_id),
    expires_at: access.expires_at,
    scope: access.scope
  };
  availableStorage()?.setItem(SESSION_KEY, JSON.stringify(session));
  return session;
}

export function getMaintenanceSession() {
  const storage = availableStorage();
  if (!storage) return null;
  try {
    const session = JSON.parse(storage.getItem(SESSION_KEY) || 'null');
    if (!session?.token || !session?.staff || !Array.isArray(session.centres) || !session.centres.length) return null;
    const validCentre = session.centres.some(centre => Number(centre.id) === Number(session.selected_centre_id));
    if (!validCentre) session.selected_centre_id = Number(session.initial_centre_id || session.centres[0].id);
    return session;
  } catch {
    storage.removeItem(SESSION_KEY);
    return null;
  }
}

export function selectMaintenanceCentre(centreId) {
  const session = getMaintenanceSession();
  if (!session || !session.centres.some(centre => Number(centre.id) === Number(centreId))) return null;
  const next = { ...session, selected_centre_id: Number(centreId) };
  availableStorage()?.setItem(SESSION_KEY, JSON.stringify(next));
  return next;
}

export function clearMaintenanceSession() {
  availableStorage()?.removeItem(SESSION_KEY);
}

export const maintenanceSessionKey = SESSION_KEY;
